import Form from 'react-bootstrap/Form';

import { DropdownMultipleComponentProps } from './dropdown-props.interface';
import './dropdown.component.scss';

import { useMultipleSelection } from './hooks/use-multiple-selection.hook';

export const MultipleSelectionOptionsComponent = ({
  MultipleSelectionOptionGroup,
  filter,
  options,
  selectedValue,
  changeValueCallback,
  disabled,
}: DropdownMultipleComponentProps) => {
  const {
    optionsGroup,
    selectionsWithoutOptionsGroup,
    changeGroupHandler,
    changeHandler,
    getGroupCheckedCounter,
    isAllChecked,
    isChecked,
    isGroupChecked,
    changeHandlerAll,
  } = useMultipleSelection(filter, options, changeValueCallback, selectedValue);

  return (
    <>
      {!filter.required && (
        <div className="dropdown-item-component">
          <Form.Check
            disabled={disabled}
            name={filter.id}
            id={`${filter.id}-all`}
            label={'All'}
            type="checkbox"
            checked={isAllChecked()}
            value={'all'}
            onChange={() => changeHandlerAll()}
          />
        </div>
      )}
      {optionsGroup.map((g, index) => (
        <MultipleSelectionOptionGroup
          key={index}
          filter={filter}
          g={g}
          changeGroupHandler={changeGroupHandler}
          changeHandler={changeHandler}
          isChecked={isChecked}
          isGroupChecked={isGroupChecked}
          counter={getGroupCheckedCounter(g)}
        />
      ))}
      {selectionsWithoutOptionsGroup.map((g, index) => (
        <MultipleSelectionOptionGroup
          key={index}
          filter={filter}
          g={g}
          changeGroupHandler={changeGroupHandler}
          changeHandler={changeHandler}
          isChecked={isChecked}
          isGroupChecked={isGroupChecked}
          counter={getGroupCheckedCounter(g)}
        />
      ))}
    </>
  );
};
